/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import LoadingButton from '@mui/lab/LoadingButton';
import { Container, Typography, Button, Stepper, Grid } from '@mui/material';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import _ from 'lodash';

import './styles.css';
import i18n from '../../helpers/i18nMain';

class Wizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      skipped: new Set(),
      isSubmit: false,
      isNextProc: false,
      isBackProc: false,
    };
  }

  isStepOptional = step => {
    const { optional } = this.props;
    if (optional) {
      return optional[step];
    }
    return false;
  };

  isStepSkipped = step => {
    return this.state.skipped.has(step);
  };

  nextStep = () => {
    const { activeStep, skipped } = this.state;
    const { steps } = this.props;
    let newSkipped = skipped;
    if (this.isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    if (activeStep < steps.length - 1) {
      this.setState(prevState => ({
        activeStep: prevState.activeStep + 1,
        skipped: newSkipped,
      }));
    }
  };

  backStep = () => {
    this.setState(prevState => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  handleSkip = () => {
    if (!this.isStepOptional(this.state.activeStep)) {
      // You probably want to guard against something like this,
      // it should never occur unless someone's actively trying to break something.
      throw new Error("You can't skip a step that isn't optional.");
    }
    this.setState(prevState => {
      const newSkipped = new Set(prevState.skipped.values());
      newSkipped.add(prevState.activeStep);

      return {
        activeStep: prevState.activeStep + 1,
        skipped: newSkipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  setNextProcStatus = s => {
    this.setState({ isNextProc: s });
  };

  setBackProcStatus = s => {
    this.setState({ isBackProc: s });
  };

  handleOnSubmitReset = () => {
    this.props.onSubmit(this.handleReset);
  };

  render() {
    const { activeStep, isSubmit, isNextProc, isBackProc } = this.state;
    const { children, steps, requestSubmitted, onReset } = this.props;
    let renChild = null;
    let nextValidation = false;
    let backValidation = false;
    let onNextPress = null;
    let onBackPress = null;

    const nextText = i18n.t('libraryScreenTranslations:CONTINUE');
    const processingText = i18n.t('libraryScreenTranslations:PROC');
    let backText = null;
    if (isBackProc) {
      backText = processingText;
    } else {
      backText = i18n.t('libraryScreenTranslations:BACK');
    }
    let nextProcText = null;
    if (isNextProc) {
      nextProcText = processingText;
    } else {
      nextProcText = nextText;
    }
    let submitProcText = null;
    if (isSubmit) {
      submitProcText = processingText;
    } else {
      submitProcText = i18n.t('libraryScreenTranslations:SUBMIT');
    }

    children.map((c, i) => {
      if (i === activeStep) {
        renChild = c;
        if (_.isBoolean(c.props.nextValidation)) {
          nextValidation = !c.props.nextValidation;
        } else if (c.props.nextValidation) {
          nextValidation = true;
        }
        if (_.isBoolean(c.props.backValidation)) {
          backValidation = !c.props.backValidation;
        } else if (c.props.backValidation) {
          backValidation = true;
        }
        if (c.props.onNextPress) {
          onNextPress = c.props.onNextPress;
        }
        if (c.props.onBackPress) {
          onBackPress = c.props.onBackPress;
        }
      }
      return null;
    });

    return (
      <Container>
        <Box>
          <Grid
            container
            flexDirection="row"
            justifyContent="space-between"
            spacing={2}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={10} sx={{ mt: 2 }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};
                  if (this.isStepOptional(index)) {
                    labelProps.optional = (
                      <Typography variant="caption" sx={{ fontSize: { xs: 10, sm: 14, md: 14 } }}>
                        {i18n.t('libraryScreenTranslations:OPTIONAL')}
                      </Typography>
                    );
                  }
                  if (this.isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={index.toString()} {...stepProps} classes={{ root: 'MuiStep-root' }}>
                      <StepLabel
                        {...labelProps}
                        sx={{ width: { xs: '82px', md: '100%' } }}
                        classes={{ root: 'MuiStepLabel-label' }}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </Grid>
            <Grid item xs={12} sm={12} md={2} textAlign="end" sx={{ mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontSize: { xs: 10, md: 14 },
                }}
                onClick={() => {
                  this.setState({ activeStep: 0 });
                  onReset();
                }}
              >
                {i18n.t('libraryScreenTranslations:RESET')}
              </Button>
            </Grid>
          </Grid>
          <Box sx={{ height: '50vh', overflowY: 'auto', mt: 3 }}>{renChild}</Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              mt: 4,
              mb: 2,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              sx={{
                fontSize: { xs: 10, md: 14 },
                mr: 1,
              }}
              startIcon={<KeyboardBackspaceIcon />}
              disabled={activeStep === 0 || backValidation || isBackProc}
              onClick={() => {
                if (onBackPress !== null) {
                  onBackPress();
                } else {
                  this.backStep();
                }
              }}
            >
              {backText}
            </Button>
            <Box sx={{ flex: '1 1 auto' }} />
            {this.isStepOptional(activeStep) && (
              <Button
                variant="outlined"
                color="inherit"
                onClick={this.handleSkip}
                sx={{
                  fontSize: { xs: 10, md: 14 },
                  mr: 1,
                }}
              >
                {i18n.t('libraryScreenTranslations:SKIP')}
              </Button>
            )}
            {activeStep === steps.length - 1 ? (
              <LoadingButton
                loading={requestSubmitted}
                disabled={nextValidation || isSubmit}
                sx={{
                  fontSize: { xs: 10, md: 14 },
                }}
                onClick={this.handleOnSubmitReset}
                color="primary"
                variant="contained"
              >
                {submitProcText}
              </LoadingButton>
            ) : (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (onNextPress !== null) {
                    onNextPress();
                  } else {
                    this.nextStep();
                  }
                }}
                disabled={nextValidation || isNextProc}
                sx={{
                  fontSize: { xs: 10, md: 14 },
                }}
              >
                {nextProcText}
              </Button>
            )}
          </Box>
        </Box>
      </Container>
    );
  }
}

export default Wizard;
